import { render, staticRenderFns } from "./MarketChannel.vue?vue&type=template&id=1719ad77&"
import script from "./MarketChannel.vue?vue&type=script&lang=js&"
export * from "./MarketChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports